module.exports = __webpack_public_path__ + "static/facilities-f405a042ee3c06d0687785b50edf3ad3.svg";